import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { datumService } from './services/DatumService.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { zeigeDienstplan, erstelleSchichtVorlageSelect } from './dienstplan.js';
import { debounce } from './util.js';
import { erstelleZeitblockTabelle, offenerZeitblock } from './zeitblock.js';
import { speichereSchichtVorlage, loescheSchichtVorlage } from './schichtEditor.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { Egfz } from '../../../shared/services/Egfz.js';

const debounceUpdateTagesnotiz = debounce(async (args) => {
    await updateTagesNotiz(args[0]);
});

// Toolbar Funktionen
const toolbarFun = {};
toolbarFun.sortNamen = sortNamen;
toolbarFun.sortRank = sortRank;
toolbarFun.kopiereDienstplan = kopiereDienstplan;
toolbarFun.wechsleBereich = wechsleBereich;
toolbarFun.wechsleWoche = wechsleWoche;
toolbarFun.erstelleSchichtVorlagenInputFeld = erstelleSchichtVorlagenInputFeld;
toolbarFun.schichtenFreigebenWoche = schichtenFreigebenWoche;
toolbarFun.debounceUpdateTagesnotiz = debounceUpdateTagesnotiz;
toolbarFun.schichtenFreigebenWoche = schichtenFreigebenWoche;
toolbarFun.mitarbeiterAuswahlPosten = mitarbeiterAuswahlPosten;
toolbarFun.printDienstplan = printDienstplan;
toolbarFun.clickWochenauswahl = clickWochenauswahl;
toolbarFun.updateKWoptions = updateKWoptions;

// Relevante HTML Elemente auf die oft zugegriffen wird
const modal = document.getElementById('my-modal');
const schichtVorlageTemplate = document.querySelector('[template-schicht-vorlage-input]');

async function printDienstplan() {
    const chunkArray = (inputArray) => {
        const result = [];
        for (let i = 0; i < inputArray.length; i += 10) {
          result.push(inputArray.slice(i, i + 10));
        }
        return result;
    };
    // Wir müssen alle leeren Zeilen im Druck ausblenden...
    const gridItems = [...document.querySelectorAll('.grid-element.tag')];
    // eine reihe besteht aus 10 grid elements
    const gridRows = chunkArray(gridItems);
    // wir überprüfen ob jede reihe mindestens ein schicht element hat.
    for (const row of gridRows) {
        // wenn es ein Schicht Element gibt, blenden wir es im Druck nicht aus.
        if (row.some((elem) => elem.querySelector('.schicht-div:not(.schicht-panel)') !== null)) {
            row.forEach((elem) => elem.classList.remove('hidden-print'));
        } else {
            row.forEach((elem) => elem.classList.add('hidden-print'));
        }
    }
    // ausdrucken
    window.print();
}

/**
 * Wechselt die Kalenderwoche und lädt den Dienstplan
 * @param {int} wechselWert
 */
 async function wechsleWoche(wechselWert) {
    toggleLoader();
    const grid = document.getElementById('grid');
    const eingeklapptePosten = [];
    [...grid.querySelectorAll('.area-header-closed')].forEach((posten) => eingeklapptePosten.push(posten.id));
    const scrollTop = grid.scrollTop;
	datumService.wechsleWoche(wechselWert);
    await zeigeDienstplan();
    // gleiche Scrollhöhe
    grid.scrollTop = scrollTop;
    // Eingeklappte Posten wieder einklappen
    [...grid.querySelectorAll('.area-header')].forEach((posten) => {
        if (eingeklapptePosten.includes(posten.id)) {
            posten.classList.toggle('area-header-closed');
            const postenItems = [...document.body.querySelectorAll(`[aria-level="${posten.id.split('-')[0]}"]`)];
	        postenItems.forEach((item) => item.classList.toggle('hidden'));
        } 
    });
    toggleLoader();
}

/**
 * Zeigt den Dienstplan von dem ausgewählten Bereich an
 * @param {*} event
 */
 async function wechsleBereich() {
	return zeigeDienstplan(true, false, true);
}

/**
 * Sortiert die Tabelle nach Namen der Mitarbeiter
 */
async function sortNamen() {
    const iconAZ = document.getElementById('sort-az');
    if (iconAZ.className === 'bi bi-sort-alpha-up') {
        stammdatenService.sort = 1;
        iconAZ.className = 'bi bi-sort-alpha-down';
    } else {
        stammdatenService.sort = -1;
        iconAZ.className = 'bi bi-sort-alpha-up';
    }
    zeigeDienstplan();
}

/**
 * Sortiert die Tabelle nach der Sortierreihenfolge der Mitarbeiter
 */
async function sortRank() {
    stammdatenService.sort = 0;
    zeigeDienstplan();
}

/**
 * Kopiert den aktuellen Dienstplan in die nächste Woche
 */
async function kopiereDienstplan() {
    // Ausgewählter Zeitraum
    const kwSelect = document.getElementById('kopieren-tb-select');
    const kwDifferenz = kwSelect.value;

    // Auswahl Mitarbeiter
    const mitarbeiterCheck = document.querySelectorAll('.ma-auswahl');
    const mitarbeiterAuswahl = [...mitarbeiterCheck].filter((ma) => ma.checked);
    // Wir wollen eine Liste an ausgewählten MitarbeiterIDs
    const mitarbeiterListe = [];
    // die MitarbeiterID ist im aria-label Attribut gespeichert.
    mitarbeiterAuswahl.forEach((ma) => mitarbeiterListe.push(ma.getAttribute('aria-label')));

    // ans backend Datum KW bis (aktuell) und von wann
    const kwDatumBis = datumService.laufendesDatum;
    const kwDatumVon = datumService.laufendesDatum.subtract(kwDifferenz, 'weeks');
    const result = await schichtenService.kopiereSchichtenKW(kwDatumVon.format('YYYY-MM-DD'), kwDatumBis.format('YYYY-MM-DD'), mitarbeiterListe);
    zeigeDienstplan();
    if (result === 200) {
        await SystemDialogService.instance.displayAsync('erfolg-schicht-copy-dialog');
    } else if (result === 404) {
        await SystemDialogService.instance.displayAsync('warnung-schicht-copy-dialog');
    } else {
        await SystemDialogService.instance.displayAsync('fehler-schicht-copy-dialog');
    }
}

/**
 * Rendert den Editor für die Bearbeitung von Vorlagen
 */
async function erstelleSchichtVorlagenInputFeld(vorlageID = '') {
    let value = vorlageID;
    const toolbarSelect = document.getElementById('vorlage-tb-select');
    if (!value) {
        value = toolbarSelect.value;
    } 
    // Falls die aktive Vorlage im Select nicht gleich dem Klick auf dem Sidebar Toolbtn ist, dann ändern.
    if (vorlageID !== '' && toolbarSelect.value !== vorlageID) {
        toolbarSelect.value = vorlageID;
    }
    // Wir verhindern, dass EGFZ Schichten bearbeitet werden können
    if (!isNaN(value) && _.values(Egfz).includes(parseInt(value, 10))) {
        zeigeKleineNachricht('EGFZ kann nicht bearbeitet werden!', 0);
        return;
    }

	const datum = datumService.laufendesDatum;
    const schicht = {
        Datum: datum,
		Zeitbloecke: [],
	};
	// Reset des Modals
	const modalText = document.getElementById('modal-text');
	modalText.innerHTML = '';

	// Kopieren des Templates
	const inputFeld = schichtVorlageTemplate.content.cloneNode(true).children[0];
    inputFeld.querySelector('#input-datum').innerText = schicht.Datum.format('DD.MM.YYYY');

	// Auswahl der bereits existierenden Vorlagen
	const inputDiv = inputFeld.querySelector('#input-vorlagen');
	const vorlageSelect = await erstelleSchichtVorlageSelect();
	inputDiv.appendChild(vorlageSelect);

   	// Input für ganztags
	const inputGanztags = inputFeld.querySelector('#input-schicht-ganztags');
    inputGanztags.checked = schicht.Ganztags ?? false;
	// Input für offener Beginn
	const inputOffenerBeginn = inputFeld.querySelector('#input-schicht-offener-beginn');
	inputOffenerBeginn.checked = schicht.OffenerBeginn ? schicht.OffenerBeginn : false;
	inputOffenerBeginn.addEventListener('input', () => {
		if (!inputOffenerBeginn.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputOffenerBeginn.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, false, undefined);
		}
	});
	// Input für offenes Ende
	const inputOffenesEnde = inputFeld.querySelector('#input-schicht-offenes-ende');
	inputOffenesEnde.checked = schicht.OffenesEnde ? schicht.OffenesEnde : false;
	inputOffenesEnde.addEventListener('input', () => {
		if (!inputOffenesEnde.checked) {
			inputGanztags.checked = false;
		}
		// Falls wir die checkbox auf true gesetzt haben, blenden wir einen Zeitblock mit Sollstunden ein.
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputOffenesEnde.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, true, undefined);
		}
	});


	inputGanztags.checked = schicht.Ganztags ? schicht.Ganztags : false;
	inputGanztags.addEventListener('input', () => {
		if (inputGanztags.checked) {
			inputOffenerBeginn.checked = true;
			inputOffenesEnde.checked = true;
		}
		// ...außer es wurden mehrere Zeitblöcke definiert (<=2 da die erste table row die Titelzeile ist)
		const table = document.getElementById('zeiten-tabelle');
		if (inputGanztags.checked && table.rows.length <= 2) {
			offenerZeitblock(schicht, false, undefined, true);
		}
	});

    // SchichtFarbe übernehmen
    inputFeld.querySelector('#input-schicht-farbe').value = schicht.SchichtFarbe ? schicht.SchichtFarbe : '#0071bd';
    // Schicht Notiz übernehmen
	inputFeld.querySelector('#input-schicht-notiz').value = schicht.SchichtNotiz ? schicht.SchichtNotiz : '';

    // Vorlage Button Event Handlers
    const vorlageSubmit = inputFeld.querySelector('#vorlage-submit');
	vorlageSubmit.addEventListener('click', async () => speichereSchichtVorlage(schicht));
    const vorlageDelete = inputFeld.querySelector('#vorlage-delete');
    vorlageDelete.addEventListener('click', async () => loescheSchichtVorlage());

    // Zeige das befüllte Input Feld an
    modalText.appendChild(inputFeld);
	modal.style.display = 'block';

    // Erstelle Zeitblock Input
    if (toolbarSelect.value !== '') {
        // Übernehmen der Attribute aus der ausgewählten Vorlage...
        const vorlage = await schichtenService.holeSchichtObjekt(toolbarSelect.value);
        vorlageSelect.value = toolbarSelect.value;
        document.getElementById('input-vorlage-titel').value = vorlage.Titel;
        inputGanztags.checked = vorlage.Ganztags ?? false;
        inputOffenerBeginn.checked = vorlage.OffenerBeginn;
        inputOffenesEnde.checked = vorlage.OffenesEnde;
        inputFeld.querySelector('#input-schicht-farbe').value = vorlage.SchichtFarbe ? vorlage.SchichtFarbe : '#0071bd';
        inputFeld.querySelector('#input-schicht-notiz').value = vorlage.SchichtNotiz ? vorlage.SchichtNotiz : '';
        erstelleZeitblockTabelle(vorlage, 0);
    } else {
        erstelleZeitblockTabelle(schicht, 0);
    }
}

/**
 * Update der Tagesnotiz
 * @param {HTMLElement} thisElement HTML Input Element
 */
async function updateTagesNotiz(thisElement) {
    // Wochentag ist in der ID gespeichert notiz:wochentag, z.B. notiz:1 ist Montag
    const wochentag = parseInt(thisElement.parentNode.id.split(':')[1], 10);
    // das Datum muss dem laufendem Datum + Wochentag sein. (+0 falls montag, +6 falls sonntag)
    const datumInput = datumService.laufendesDatum.add(wochentag - 1, 'days');
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    if (betriebsstaetteID.value === '') {
        zeigeKleineNachricht('Keine Betriebsstätte ausgewählt!', -1);
        return;
    }
    const notiz = thisElement.value;
    await stammdatenService.fetchUpdateTagesNotiz(notiz, datumInput.format('YYYY-MM-DD'), betriebsstaetteID);
}

/**
 * Klick Handler, der das Freigaben der Schichten eines Postens einleitet.
 * @param {string} postenID
 */
async function schichtenFreigebenWoche(postenID) {
    const betriebsstaetteID = document.getElementById('select-betriebsstaette').value;
    const wocheStart = datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD');
    const wocheEnde = datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD');
    const result = await schichtenService.freigabeSchichten(postenID, wocheStart, wocheEnde, betriebsstaetteID);
    if (!result) {
        return;
    }
    // nun alle Schichten des Postens als freigeben markieren
    // 1. Schritt alle Schichten des Postens finden...
    // Die Kopierquelle-Vorschau hat zwar die gleiche aria-description, aber kein [schicht-freigabe-status] Element -> ausschließen.
    const schichtenPostenHTML = [...document.querySelectorAll(`[aria-description="${postenID}"]:not(.kopier-quelle-vorschau)`)];
    // 2. Schritt alle Freigeben Circle Icons updaten
    // Nur die Klasse des Freigabe-<i> ändern statt innerHTML neu zu setzen, sonst geht der Kopier-Button (+ Listener) verloren.
    schichtenPostenHTML.forEach((schicht) => {
        const freigabeIcon = schicht.querySelector('[schicht-freigabe-status] > i');
        if (!freigabeIcon) return;
        freigabeIcon.classList.remove('bi-circle');
        freigabeIcon.classList.add('bi-circle-fill');
        freigabeIcon.title = 'Schicht freigegeben';
    });
}

function mitarbeiterAuswahlPosten(postenID) {
    const mitarbeiterChecks = [...document.querySelectorAll(`input[aria-level="${postenID}"]`)];
    const alreadyChecked = mitarbeiterChecks.every((ma) => ma.checked);
    mitarbeiterChecks.forEach((checkbox) => {
        checkbox.checked = !alreadyChecked;
    });
}

async function clickWochenauswahl() {
    const jahr = datumService.laufendesDatum.year();
    const kw = datumService.kalenderWoche;
    document.getElementById('dialog-kal-year').value = jahr;
    updateKWoptions(jahr, kw);
    const result = await SystemDialogService.instance.displayAsync('kalender-woche-dialog');
    if (result.success) {
        const dateFromWeek = datumService.laufendesDatum.year(result.data.Year).week(result.data.Week);
        const diffWeeks = dateFromWeek.diff(datumService.laufendesDatum, 'week', false);
        console.log(diffWeeks);
        if (!diffWeeks) return;
        wechsleWoche(diffWeeks);
    }
}

function updateKWoptions(year, kw) {
    const kalWeekInput = document.getElementById('dialog-kal-week');
    const prev = kw || kalWeekInput.value;
    kalWeekInput.innerHTML = '';
    const weeksInYear = dayjs(`${year}-01-01`).isoWeeksInYear();
    let tmpDate = dayjs(`${year}-01-01`);
    for (let i = 1; i <= dayjs(`${year}-01-01`).isoWeeksInYear(); i++) {
        const option = document.createElement('option');
        option.value = i;
        option.innerText = `KW ${i} (${tmpDate.startOf('week').tz().format('DD.MM.YYYY')} - ${tmpDate.endOf('week').tz().format('DD.MM.YYYY')})`;
        kalWeekInput.appendChild(option);
        tmpDate = tmpDate.add(1, 'weeks');
    }
    kalWeekInput.value = Math.min(weeksInYear, prev);
}

export { toolbarFun };
